/**
 * Products Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/done/products-public-catalog.md
 */

// Leerer String = kein Driver — Core akzeptiert "" oder null für reine
// valiKey-Produkte (SSO-Abo, Lizenzen, etc.) ohne Provisioning. Per Spec
// datenmodelle/core.api.valitype.net/product.md L50.
export const KNOWN_DRIVERS = ['', 'pterodactyl', 'enhance', 'inwx-domain', 'cloudflare', 'registrar', 'wireguard'];
export const KNOWN_TAX_CATEGORIES = ['standard', 'reduced', 'reverse_charge', 'exempt'];
export const KNOWN_INTERVALS = ['', 'day', 'week', 'month', 'year'];

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_PRODUCTS_DB__) {
    const now = Date.now();
    window.__ORBIT_PRODUCTS_DB__ = [
      {
        id: 101,
        sku: 'pro-monthly',
        name: 'Pro · Monatlich',
        description: 'Bis 5 Websites, 50 GB NVMe, tägliche Backups.',
        driver: 'enhance',
        driverConfig: { packageId: 'pkg-pro', backupSchedule: 'daily' },
        unitAmount: 1999,
        currency: 'EUR',
        vatRate: 19,
        taxCategory: 'standard',
        recurring: true,
        billingInterval: 'month',
        trialPeriodDays: 14,
        minimumTermMonths: 0,
        noticePeriodDays: 30,
        isActive: true,
        createdAt: new Date(now - 200 * 86_400_000).toISOString(),
        updatedAt: new Date(now - 30 * 86_400_000).toISOString(),
      },
      {
        id: 102,
        sku: 'business-yearly',
        name: 'Business · Jährlich',
        description: 'Unlimited Sites, 500 GB NVMe, Priority Support.',
        driver: 'enhance',
        driverConfig: { packageId: 'pkg-business' },
        unitAmount: 19900,
        currency: 'EUR',
        vatRate: 19,
        taxCategory: 'standard',
        recurring: true,
        billingInterval: 'year',
        trialPeriodDays: 0,
        minimumTermMonths: 12,
        noticePeriodDays: 90,
        isActive: true,
        createdAt: new Date(now - 200 * 86_400_000).toISOString(),
        updatedAt: new Date(now - 90 * 86_400_000).toISOString(),
      },
      {
        id: 103,
        sku: 'starter-monthly',
        name: 'Starter · Monatlich',
        description: '1 Site, 5 GB NVMe.',
        driver: 'enhance',
        driverConfig: { packageId: 'pkg-starter' },
        unitAmount: 499,
        currency: 'EUR',
        vatRate: 19,
        taxCategory: 'standard',
        recurring: true,
        billingInterval: 'month',
        trialPeriodDays: 7,
        minimumTermMonths: 0,
        noticePeriodDays: 30,
        isActive: true,
        createdAt: new Date(now - 100 * 86_400_000).toISOString(),
        updatedAt: new Date(now - 100 * 86_400_000).toISOString(),
      },
      {
        id: 104,
        sku: 'addon-backup',
        name: 'Backup-Addon (zusätzliche Retention)',
        description: '90 Tage Retention statt 14.',
        driver: 'enhance',
        driverConfig: {},
        unitAmount: 499,
        currency: 'EUR',
        vatRate: 19,
        taxCategory: 'standard',
        recurring: true,
        billingInterval: 'month',
        trialPeriodDays: 0,
        minimumTermMonths: 0,
        noticePeriodDays: 30,
        isActive: true,
        createdAt: new Date(now - 60 * 86_400_000).toISOString(),
        updatedAt: new Date(now - 60 * 86_400_000).toISOString(),
      },
      {
        id: 105,
        sku: 'legacy-mini',
        name: 'Legacy Mini (deprecated)',
        description: 'Wird nicht mehr aktiv verkauft.',
        driver: 'enhance',
        driverConfig: {},
        unitAmount: 299,
        currency: 'EUR',
        vatRate: 19,
        taxCategory: 'standard',
        recurring: true,
        billingInterval: 'month',
        trialPeriodDays: 0,
        minimumTermMonths: 0,
        noticePeriodDays: 30,
        isActive: false,
        createdAt: new Date(now - 800 * 86_400_000).toISOString(),
        updatedAt: new Date(now - 90 * 86_400_000).toISOString(),
      },
    ];
  }
  return window.__ORBIT_PRODUCTS_DB__;
}

export function productsFixture() {
  return { products: [...persist()] };
}

export function createProductFixture(payload) {
  const db = persist();
  if (db.some((p) => p.sku === payload.sku)) {
    const err = new Error(`SKU "${payload.sku}" existiert bereits in dieser Brand.`);
    err.code = 'ER_DUP_ENTRY';
    err.status = 409;
    throw err;
  }
  const id = Math.max(0, ...db.map((p) => p.id)) + 1;
  const now = new Date().toISOString();
  const product = {
    id,
    isActive: true,
    createdAt: now,
    updatedAt: now,
    ...payload,
  };
  db.push(product);
  return { product };
}

export function updateProductFixture(id, patch) {
  const db = persist();
  const target = db.find((p) => p.id === Number(id));
  if (!target) throw new Error(`Product ${id} nicht gefunden`);
  // SKU ist nach Create read-only (Snapshot in Order-Items)
  const { sku: _sku, ...allowed } = patch;
  Object.assign(target, allowed, { updatedAt: new Date().toISOString() });
  return { product: target };
}

export function deleteProductFixture(id) {
  const db = persist();
  const target = db.find((p) => p.id === Number(id));
  if (target) {
    target.isActive = false;
    target.updatedAt = new Date().toISOString();
  }
  return { ok: true };
}
